export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export interface PasswordValidationResult {
  isValid: boolean;
  requirements: Array<PasswordRequirement & { isMet: boolean }>;
}

const SPECIAL_CHARS = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=\s]/;
const HAS_NUMBER = /\d/;
const HAS_UPPERCASE = /[A-Z]/;
const HAS_LOWERCASE = /[a-z]/;
const MIN_LENGTH = 12;

export const passwordRequirements: PasswordRequirement[] = [
  {
    id: 'minLength',
    label: `At least ${MIN_LENGTH} characters`,
    test: (password: string) => password.length >= MIN_LENGTH,
  },
  {
    id: 'hasNumber',
    label: 'Contains a number',
    test: (password: string) => HAS_NUMBER.test(password),
  },
  {
    id: 'hasUppercase',
    label: 'Contains an uppercase letter',
    test: (password: string) => HAS_UPPERCASE.test(password),
  },
  {
    id: 'hasLowercase',
    label: 'Contains a lowercase letter',
    test: (password: string) => HAS_LOWERCASE.test(password),
  },
  {
    id: 'hasSpecial',
    label: 'Contains a special character',
    test: (password: string) => SPECIAL_CHARS.test(password),
  },
];

export function validatePassword(password: string): PasswordValidationResult {
  const requirements = passwordRequirements.map((req) => ({
    ...req,
    isMet: req.test(password),
  }));

  const isValid = requirements.every((req) => req.isMet);

  return { isValid, requirements };
}

export function isPasswordValid(password: string): boolean {
  return validatePassword(password).isValid;
}
